import React from 'react'
import { Grid } from 'semantic-ui-react'
import { withTwilight } from 'loankeeper-common/components/hocs/Twilight'

import { LocalLoader } from 'shared'
//@ts-ignore
import { GridContainer } from 'shared/StyledComponents'
//@ts-ignore
import withLivedata from 'shared/containers/withLivedata'

import DatePickerSection from './DateSearchBar'
import InfoDataTable from './InfoDataTable'
import { ReserveCalcProps } from 'src/features/LoanDetails/types.LoanDetails'
import { connect } from 'react-redux'
import { loanView } from 'src/store/loan'
import { AppDispatch } from 'src/store/index.d'
import { LoanViewParams } from '@lk/api'

//@ts-ignore
@withTwilight
@withLivedata('OpenDayStatus.Open_Day_Str as OpenDay')
//@ts-ignore
@connect(undefined, (dispatch: AppDispatch) => ({
  getLoanDetails: (params: LoanViewParams) => dispatch(loanView(params)),
}))
class ReserveCalc extends React.Component<ReserveCalcProps> {
  state = {
    data: {},
    isFetching: false,
    EndDate: this.props.OpenDay,
  }

  componentDidMount() {
    this.loadReserveCalc(this.state.EndDate)
  }

  loadReserveCalc = (EndDate: string) => {
    // const params = {
    //   ID: this.props.ID,
    //   hash: this.props.hash,
    //   page: 'reservecalc',
    //   additionalParams: { EndDate },
    // }

    const params = {
      LoanID: this.props.ID,
      HashSum_LoanID_: this.props.hash,
      page: 'reservecalc',
      ActiveOperFlag: 1,
      EndDate,
    }

    this.setState({ isFetching: true }, () => {
      this.props.startTwilight()

      let data = {}

      // Loan.details(params)
      //   .then(({ Data }) => {
      //     data = Data
      //   })
      //   .catch((err) => console.error(err))
      //   .finally(() => {
      //     this.setState({ data, isFetching: false }, this.props.endTwilight)
      //   })

      //UPDATED API REQUEST loan_view_api page: reservecalc
      this.props
        .getLoanDetails(params)
        .then((response) => {
          if (!loanView.fulfilled.match(response)) {
            return
          }
          data = response.payload
        })
        .finally(() => {
          this.setState({ data, isFetching: false }, this.props.endTwilight)
        })
    })
  }

  handleSubmit = (values: { EndDate: string }) => {
    this.setState({ EndDate: values.EndDate }, () => {
      this.loadReserveCalc(this.state.EndDate)
    })
  }

  render() {
    const { isFetching, data, EndDate } = this.state

    return (
      <LocalLoader>
        <GridContainer>
          <Grid>
            <Grid.Row columns={1}>
              {/*@ts-ignore */}
              <DatePickerSection loading={isFetching} initialValues={{ EndDate }} onSubmit={this.handleSubmit} />

              {!isFetching && <InfoDataTable data={data} />}
            </Grid.Row>
          </Grid>
        </GridContainer>
      </LocalLoader>
    )
  }
}

export default ReserveCalc
